/** Sayfa bazlı SEO: title, description, canonical, Open Graph ve robots etiketleri. */
import { useEffect } from "react";
import { BRAND } from "@/lib/brand";

const SITE = "https://ciftora.com";

const setMeta = (selector, attr, key, value) => {
  if (!value) return;
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
};

export function useSeo({ title, description, path, image, noindex = false, jsonLd } = {}) {
  useEffect(() => {
    const fullTitle = title ? `${title} | Ciftora` : `Ciftora | ${BRAND.slogan}`;
    document.title = fullTitle;
    setMeta('meta[name="description"]', "name", "description", description);
    setMeta('meta[property="og:title"]', "property", "og:title", fullTitle);
    setMeta('meta[property="og:description"]', "property", "og:description", description);
    setMeta('meta[name="twitter:title"]', "name", "twitter:title", fullTitle);
    const url = `${SITE}${path || window.location.pathname}`;
    setMeta('meta[property="og:url"]', "property", "og:url", url);
    if (image) {
      setMeta('meta[property="og:image"]', "property", "og:image", image);
      setMeta('meta[name="twitter:image"]', "name", "twitter:image", image);
    }
    setMeta('meta[name="robots"]', "name", "robots", noindex ? "noindex, nofollow" : "index, follow");

    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = url;

    let script = document.getElementById("ciftora-jsonld");
    if (jsonLd) {
      if (!script) {
        script = document.createElement("script");
        script.id = "ciftora-jsonld";
        script.type = "application/ld+json";
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    } else if (script) {
      script.remove();
    }
  }, [title, description, path, image, noindex, jsonLd]);
}
